import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';

export const SITE_NAME = 'Spinning Heracles Westerlo';
export const DEFAULT_TITLE = `${SITE_NAME} — reserveer je spinningles`;

@Injectable({providedIn: 'root'})
export class AppTitleStrategy extends TitleStrategy {

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    this.title.setTitle(pageTitle ? `${pageTitle} — ${SITE_NAME}` : DEFAULT_TITLE);
  }
}
